import script from "./Categories.vue?vue&type=script&setup=true&lang=ts"
export * from "./Categories.vue?vue&type=script&setup=true&lang=ts"

import "./Categories.vue?vue&type=style&index=0&id=143bb372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-143bb372"]])

export default __exports__